<template>
  <parent>
    <div>
      <b-container>
        <b-row class="justify-content-center">
          <b-col
            cols="12"
            md="10"
          >
            <paper>
              <b-row
                class="mt-n2 px-2 py-1 justify-content-between align-items-center"
              >
                <b-col
                  cols="12"
                  sm="6"
                >
                  {{ outputPreset.name }}
                </b-col>
                <b-col
                  class="d-flex justify-content-sm-end justify-content-start mt-1 mt-sm-0"
                  cols="12"
                  sm="6"
                >
                  <b-button
                    variant="bg-white"
                    class="mr-1"
                    :disabled="!isEditable"
                    @click="
                      isEditable
                        ? $router.push({
                          name: 'output-presets-edit',
                          params: {
                            id: outputPreset.id,
                          },
                        })
                        : ''
                    "
                  >
                    <GjIcon
                      name="Edit"
                      class="icon-left"
                    />
                    Edit
                  </b-button>
                  <b-button
                    variant="bg-white"
                    :disabled="!isEditable"
                    @click="() => (isEditable ? deleteOutputPreset() : '')"
                  >
                    <GjIcon
                      name="Delete"
                      class="icon-left"
                    />
                    Delete
                  </b-button>
                </b-col>
              </b-row>
            </paper>
            <paper
              title="Preset Settings"
              body-class="mt-0 text-break"
            >
              <div class="px-2">
                <b-row>
                  <b-col
                    cols="12"
                    sm="6"
                  >
                    <input-field
                      name="preset_name"
                      label="Preset Name*"
                      label-position="top"
                      :info="generalInfo.presetName"
                      info-position="label"
                      @openInfo="openInfo"
                    >
                      <div>
                        {{ outputPreset.name }}
                      </div>
                    </input-field>
                  </b-col>
                  <b-col
                    cols="12"
                    sm="6"
                  >
                    <input-field
                      label="Description"
                      name="preset_description"
                      label-position="top"
                      label-weight="medium"
                    >
                      <div>
                        {{ outputPreset.description || '-' }}
                      </div>
                    </input-field>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    cols="12"
                    sm="6"
                  >
                    <input-field
                      name="preset_category"
                      label="Category"
                      label-position="top"
                    >
                      <div>
                        {{ outputPreset.category || '-' }}
                      </div>
                    </input-field>
                  </b-col>
                  <b-col
                    cols="12"
                    sm="6"
                  >
                    <input-field
                      name="preset_container"
                      label="Container"
                      label-position="top"
                    >
                      <div>
                        {{
                          getText(
                            outputPreset.container.containerOptions,
                            outputPreset.container.type,
                          )
                        }}
                      </div>
                    </input-field>
                  </b-col>
                </b-row>
              </div>
            </paper>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col
            cols="12"
            md="10"
          >
            <paper-tabbed title="Encoding Settings">
              <paper-tab
                v-if="!audioDescription && !videoDescription"
                title="None"
              >
                <div class="p-2">
                  <b-row>
                    <b-col>
                      Start by adding Video & Audio Encoding Settings
                    </b-col>
                  </b-row>
                </div>
              </paper-tab>
              <paper-tab
                v-if="videoDescription"
                title="Video"
                :active="videoTabActive"
              >
                <video-details
                  ref="videoSettingsRef"
                  @openInfo="openInfo"
                />
              </paper-tab>
              <paper-tab
                v-if="audioDescription"
                title="Audio"
                :active="audioTabActive"
              >
                <div class="px-2 pt-2">
                  <audio-details
                    ref="audioSettingsRef"
                    class="bg-red"
                    @openInfo="openInfo"
                  />
                </div>
              </paper-tab>
            </paper-tabbed>
          </b-col>
        </b-row>
      </b-container>
      <info
        v-if="infoData"
        :info="infoData"
        @close="infoData = null"
      />
    </div>
  </parent>
</template>

<script>
import { required } from '@validations'

import Paper from '@/components/paper/Paper.vue'
import PaperTabbed from '@/components/paper/PaperTabbed.vue'
import PaperTab from '@/components/paper/PaperTab.vue'
import InputField from '@/components/form/InputField.vue'
import helpers from '@/mixins/helpers'
import generalInfo from '../generalInfo'
import VideoDetails from './VideoDetails.vue'
import AudioDetails from './AudioDetails.vue'

export default {
  name: 'OutputPresetDetails',
  components: {
    Paper,
    InputField,
    PaperTabbed,
    PaperTab,
    VideoDetails,
    AudioDetails,
  },
  mixins: [helpers],
  data() {
    return {
      generalInfo,
      infoData: null,
      required,
      activeTab: 0,
      encodingActiveTab: 1,
      videoDescription: true,
      audioDescription: false,
      videoDescriptionModel: null,
      audioDescriptionModel: null,
      outputPreset: null,
    }
  },
  provide() {
    return { parentValidator: this.$validator }
  },
  computed: {
    videoTabActive() {
      return this.activeTab === 0
    },
    audioTabActive() {
      return this.activeTab === 1
    },
    buttonEnabled() {
      return false
    },
    isEditable() {
      return (
        this.outputPreset.presetType
        !== this.outputPreset.presetTypeOptions[0].id
      )
    },
  },
  created() {
    this.init()
  },
  methods: {
    openInfo(i) {
      this.infoData = i
    },
    init() {
      this.outputPreset = this.$store.state.outputPresets.outputPreset
      this.videoDescription = !!this.outputPreset.videoDescription
      this.audioDescription = !!this.outputPreset.audioDescription
    },
    deleteOutputPreset() {
      this.confirmDelete(
        'Delete output preset',
        'Are you sure you want to delete this output preset?',
      ).then(ok => {
        if (ok) {
          this.$store
            .dispatch('outputPresets/deleteOutputPreset', this.outputPreset.id)
            .then(() => {
              this.$router.push({
                name: 'output-presets',
                params: {
                  toast: {
                    title: 'Success',
                    variant: 'success',
                    message: 'Output preset deleted.',
                  },
                },
              })
            })
            .catch(() => {
              this.errorToast(
                "An error occurred, couldn't delete output preset",
                'Error',
              )
            })
        }
      })
    },
  },
}
</script>
